module.exports = __webpack_public_path__ + "static/img/mycoupon-banner.9b99a4ea.png";